import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import {
    type DateTimePickerDynamicStyleType,
    type DateTimePickerTypeConstantType,
    type DateTimePickerType
} from "./type";
import type {
    Mutable
} from "../../types";
import type {
    FieldType
} from "../fieldControl/type";
import {
    webStyle
} from "../../utils";

export const DATE_TIME_PICKER_TYPES: Record<DateTimePickerType, FieldType> = {
    question: "neutral",
    default: "neutral",
    neutral: "neutral",
    success: "success",
    warning: "warning",
    danger: "danger",
    info: "info"
};

export const getDateTimePickerType = ({
    type
}: DateTimePickerTypeConstantType): FieldType => {
    return DATE_TIME_PICKER_TYPES[type];
};

const stylesheet = StyleSheet.create({
    readOnlyInput: {
        backgroundColor: "transparent",
        textAlignVertical: "center",
        includeFontPadding: false,
        alignSelf: "stretch",
        borderWidth: 0,
        minWidth: 0,
        padding: 0,
        margin: 0,
        flex: 1
    },
    trigger: {
        flexDirection: "row",
        alignItems: "center",
        alignSelf: "stretch",
        minWidth: 0,
        flex: 1,
        ...webStyle({
            outlineStyle: "solid",
            cursor: "pointer",
            outlineWidth: 0
        })
    },
    loadingTrigger: {
        ...webStyle({
            cursor: "not-allowed"
        })
    },
    value: {
        flexShrink: 1
    }
});

export const useStyles = ({
    isLoading
}: DateTimePickerDynamicStyleType) => {
    const styles = {
        trigger: {
        } as Mutable<ViewStyle>
    };

    if(isLoading) {
        Object.assign(styles.trigger, stylesheet.loadingTrigger);
    }

    return styles;
};
export default stylesheet;
